<template>
  <div id="supporting-details" class="page-top">
    <HeroBanner :title="'Supporting Details'" :subtitle="'Enter details and upload relevant documents in support of your invention'"/>
    <section>
      <div class="col1">
        <transition name="fade">
          <p v-if="showSuccess" class="success-msg">Profile successfully updated</p>
        </transition>
        <FormulateForm
          ref="SupportingDetailsForm"
          v-if="supportingDetailsFormValues && showForm"
          v-model="supportingDetailsFormValues"
          :schema="supportingDetailsSchema"
          @submit="supportingDetailsSubmit"
        />
        <div class="upload-btn-wrap">
          <button @click="onSubmit" :disabled="pending" class="button" v-html="pending ? 'Please Wait...' : 'Save'"/>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import HeroBanner from '@/components/HeroBanner'
import updateProfileMixin from '@/mixins/updateProfileMixin'

export default {
  name: 'SupportingDetails',
  data(){
    return {
      uploadProgress: 0,
      uploadedDocs: [],
      showSuccess: false,
    }
  },
  components: {
    HeroBanner
  },
  computed: {
    ...mapGetters([
      'currentUserProfile'
    ])
  },
  methods: {
    ...mapActions(['setTimelineStep']),
    onSubmit(){
      this.$refs.SupportingDetailsForm.formSubmitted()

      this.setTimelineStep(7)

      this.$router.push('/')

      this.$notify({
        group: 'default',
        title: 'Success',
        text: `You saved supporting details to your profile`,
        type: 'success'
      })

    }
  },
  mixins: [
    updateProfileMixin
  ]
}
</script>

<style scoped lang="scss">
img.preview {
  width: 200px;
}
.col1 {
  padding: 4rem;
}
.col2 img {
  max-width: 100%;
}
.input-wrap {
  padding: 2rem;
  border: solid 1px #ccc;
}
.upload-btn-wrap {
  padding: 2rem 0;
  button {
    @include btn-primary;
  }
}
/deep/ {
  @include formStyles;
}
</style>